module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-with-text-2fcbc71b489e502a999718e27317f6ef.png";